import { useHistory } from 'Logic/FlowShortcuts.js'

let TABS_HACK = {
  apps: 'connect-apps',
}

export default function useGetDefaultTab(props, data) {
  let history = useHistory()

  return function ensureDefaultTab(maybeTab, id) {
    if (maybeTab?.selected) return maybeTab

    let [, , _tab] = history.location.pathname.split('/')

    return {
      ...data,
      selected: {
        ...data.selected,
        tab: TABS_HACK[_tab] ?? data.selected.tab,
      },
      viewPath: props.viewPath,
    }
  }
}
